export enum RegistrationRoutes {
  ApplianceDetails = '/appliance-details',
  PersonalDetails = '/personal-details',
  Checkout = '/checkout',
  CoverageInfo = '/coverage-info',
  Benefits = '/benefits',
  ProtectionDetails = '/protection-details',
  RegistrationConfirmation = '/confirmation',
  RegistrationOrderConfirmation = '/order-confirmation',
}
